"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.ringOverLetter = command_expander_1.lookupOrAppend({
    a: "å",
    A: "Å",
    y: "ẙ"
}, "\u030A");
//# sourceMappingURL=mathring.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/1args/diacritics/mathring.js
// module id = 108
// module chunks = 0 1 2 3